import {
  ActionSheet,
  Button,
  Card,
  useActionSheetProvider,
} from "@storoey/sui";
import { onCleanup } from "solid-js";
import { PhotoDto } from "../../backend/models/dto/Item.dto";
import styles from "./PhotoCard.module.scss";

export const PhotoCard = (props: {
  photo: PhotoDto & { formId: number; formName?: string };
  onDelete: (photoId: number) => void;
}) => {
  const actionsheet = useActionSheetProvider();
  const photoUrl = URL.createObjectURL(props.photo.file);

  onCleanup(() => {
    if (photoUrl) {
      URL.revokeObjectURL(photoUrl);
    }
  });

  return (
    <div>
      <Card elevation={200}>
        <Card.Content>
          <Card.Title>{props.photo.formName ?? props.photo.formId}</Card.Title>
          <Card.Text>
            {Intl.DateTimeFormat(navigator.language ?? "no-NB", {
              dateStyle: "full",
              timeStyle: "medium",
              hour12: false,
            }).format(props.photo.date)}
          </Card.Text>
        </Card.Content>
        <Card.Actions align="center">
          <img src={photoUrl} class={styles["image"]} />
        </Card.Actions>
        <Card.Actions>
          <Button color="red" variant="ghost" onClick={actionsheet.open}>
            Slett
          </Button>
        </Card.Actions>
      </Card>
      <ActionSheet isOpen={actionsheet.isOpen} close={actionsheet.close}>
        <ActionSheet.Content
          title="Er du sikker?"
          text="Denne handlingen kan ikke reverseres."
        >
          <ActionSheet.Button
            onClick={() => props.onDelete(props.photo.id)}
            danger
          >
            Slett
          </ActionSheet.Button>
        </ActionSheet.Content>
      </ActionSheet>
    </div>
  );
};
